//src/app/services/upcomingDates.ts
import api, {
  buildQueryParams,
  IGetQueryParams,
  IPaginatedRepsonse,
} from './index';
import { IUser } from './user';

export type IUpcomingDate = {
  id: number;
  date_title: string;
  description: '';
  audience: 'clients' | 'accountants' | 'all';
  started_at: string;
  ended_at: string;
  created_at: string;
  updated_at: string;
  creator: IUser;
};

export const UpcomingDatesAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    getUpcomingDates: builder.query<
      IPaginatedRepsonse<IUpcomingDate>,
      IGetQueryParams<{}>
    >({
      query: (params) => `/upcoming_dates${buildQueryParams(params)}`,
    }),

    updateUpcomingDate: builder.mutation<
      IUpcomingDate,
      Partial<IUpcomingDate> & { id: number }
    >({
      query: (upcoming_date) => ({
        url: `/upcoming_dates/${upcoming_date.id}`,
        method: 'PUT',
        body: { upcoming_date },
      }),
    }),
    createUpcomingDate: builder.mutation<IUpcomingDate, IUpcomingDate>({
      query: (upcoming_date) => ({
        url: `/upcoming_dates`,
        method: 'POST',
        body: {
          upcoming_date,
        },
      }),
    }),
    deleteUpcomingDate: builder.mutation({
      query: (id: number) => ({
        url: `/upcoming_dates/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyGetUpcomingDatesQuery,
  useCreateUpcomingDateMutation,
  useDeleteUpcomingDateMutation,
  useGetUpcomingDatesQuery,
  useUpdateUpcomingDateMutation,
} = UpcomingDatesAPI;
